import {
  ProductFeedbackFeature,
  useSubmitProductFeedback,
} from "@/hooks/use-submit-product-feedback";
import { FeedbackDialog } from "@faro-lotv/flat-ui";
import { useCallback, type JSX } from "react";

/** The question asked to the user. */
const QUESTION = "How beneficial is the analysis tool for your work?";

interface SendFeedbackFormProps {
  closeDialog(): void;
}

/**
 * Contains the send-feedback form about the color map analysis tool.
 *
 * @returns the analysis feedback form dialog
 */
export function AnalysisFeedbackForm({
  closeDialog,
}: SendFeedbackFormProps): JSX.Element {
  const submitProductFeedback = useSubmitProductFeedback();

  const onSubmitFeedback = useCallback(
    async (
      rating: number,
      feedbackText?: string,
      hasUserAllowedContact?: boolean,
    ): Promise<void> => {
      if (
        await submitProductFeedback({
          feature: ProductFeedbackFeature.pointCloudAnalysis,
          question: QUESTION,
          rating,
          message: feedbackText,
          hasUserAllowedContact,
        })
      ) {
        closeDialog();
      }
    },
    [closeDialog, submitProductFeedback],
  );

  return (
    <FeedbackDialog
      isDialogOpen
      type="numbered"
      numberedLabels={[
        "Not helpful",
        undefined,
        undefined,
        undefined,
        "Very helpful",
      ]}
      onSubmitFeedback={onSubmitFeedback}
      title={QUESTION}
      feedbackQuestionText="Additional comments (optional)"
      onClose={closeDialog}
      hideQuestionUntilRating
      showXButton={false}
    />
  );
}
